// Validación para el componente UserProfile
export const validateUserProfileField = (name, value, allValues) => {
  switch (name) {
    case "nombre":
      if (!value.trim()) {
        return "El nombre es obligatorio";
      } else if (value.trim().length < 2) {
        return "El nombre debe tener al menos 2 caracteres";
      } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value)) {
        return "El nombre solo debe contener letras";
      }
      break;

    case "apellido":
      if (!value.trim()) {
        return "El apellido es obligatorio";
      } else if (value.trim().length < 2) {
        return "El apellido debe tener al menos 2 caracteres";
      } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value)) {
        return "El apellido solo debe contener letras";
      }
      break;

    case "identificacion":
      if (!value || !value.trim()) {
        return "El número de identificación es obligatorio";
      } else if (!/^\d+$/.test(value)) {
        return "El número de identificación solo debe contener dígitos";
      } else if (allValues.tipoId === "cedula" && value.length < 8) {
        return "La cédula debe tener al menos 8 dígitos";
      } else if (allValues.tipoId === "nit" && value.length < 9) {
        return "El NIT debe tener al menos 9 dígitos";
      }
      break;

    case "banco":
      if (!value.trim()) {
        return "Debes seleccionar un banco";
      }
      break;

    case "numeroCuenta":
      if (!value.trim()) {
        return "El número de cuenta es obligatorio";
      } else if (!/^\d+$/.test(value)) {
        return "El número de cuenta solo debe contener dígitos";
      } else if (value.length < 10) {
        return "El número de cuenta debe tener al menos 10 dígitos";
      }
      break;

    default:
      return "";
  }

  return "";
};

// Validación para el componente AdminProfile (cambio de contraseña)
export const validatePasswordField = (name, value, allValues) => {
  switch (name) {
    case "currentPassword":
      if (!value.trim()) {
        return "La contraseña actual es obligatoria";
      } else if (value.length < 6) {
        return "La contraseña actual debe tener al menos 6 caracteres";
      }
      break;

    case "newPassword":
      if (!value.trim()) {
        return "La nueva contraseña es obligatoria";
      } else if (value.length < 8) {
        return "La nueva contraseña debe tener al menos 8 caracteres";
      } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) {
        return "La contraseña debe contener al menos una letra minúscula, una mayúscula y un número";
      } else if (value === allValues.currentPassword) {
        return "La nueva contraseña debe ser diferente a la actual";
      }
      break;

    case "confirmPassword":
      if (!value.trim()) {
        return "Debes confirmar la contraseña";
      } else if (value !== allValues.newPassword) {
        return "Las contraseñas no coinciden";
      }
      break;

    default:
      return "";
  }

  return "";
};
